import axios from 'axios';

import { Id, getData } from '@feature/utils';

import {
  CenterReport,
  CenterReportCriteriaData,
  CenterReportCriteriaDataRequest,
  CenterReportCriteriaInfra,
  CenterReportCriteriaInfraRequest,
  CenterReportTemplate,
  ResearchCenter,
  ResearchCenterRequest,
} from './ResearchCenterTypes';

export function getAll() {
  return axios.get<ResearchCenter[]>('/research-centers').then(getData);
}

export function get(id: Id) {
  return axios.get<ResearchCenter>(`/research-centers/${id}`).then(getData);
}

export function edit(id: Id, request: ResearchCenterRequest) {
  return axios.put<ResearchCenter>(`/research-centers/${id}`, request).then(getData);
}

export function create(request: ResearchCenterRequest) {
  return axios.post<ResearchCenter>(`/research-centers`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/research-centers/${id}`).then(getData);
}

export function getLastReport() {
  return axios.get<CenterReport>(`/research-centers/report/last`).then(getData);
}

export function getReportTemplate() {
  return axios.get<CenterReportTemplate>(`/research-centers/report/template`).then(getData);
}

export function getReportCriteriaData(labId: Id, criteriaCode: string) {
  return axios
    .get<CenterReportCriteriaData>(`/research-centers/report/lab/${labId}/criteria/${criteriaCode}/data`)
    .then(getData);
}

export function saveReportCriteriaData(labId: Id, criteriaCode: string, request: CenterReportCriteriaDataRequest) {
  return axios
    .post<unknown>(`/research-centers/report/lab/${labId}/criteria/${criteriaCode}/data`, request)
    .then(getData);
}

export function saveReportCriteriaCompleted(labId: Id, criteriaCode: string, isCompleted: boolean) {
  return axios
    .put<unknown>(`/research-centers/report/lab/${labId}/criteria/${criteriaCode}/is-complete`, undefined, {
      params: {
        isCompleted,
      },
    })
    .then(getData);
}

export function getReportCriteriaInfra(labId: Id) {
  return axios.get<CenterReportCriteriaInfra[]>(`/research-centers/report/lab/${labId}/infrastructure`).then(getData);
}

export function addReportCriteriaInfra(labId: Id, request: CenterReportCriteriaInfraRequest) {
  return axios.put<unknown>(`/research-centers/report/lab/${labId}/infrastructure`, request).then(getData);
}

export function removeReportCriteriaInfra(labId: Id, infraId: Id) {
  return axios.delete<unknown>(`/research-centers/report/lab/${labId}/infrastructure/${infraId}`).then(getData);
}
